// extracted by mini-css-extract-plugin
export default {"container":"ReverseTransactionAmountModal__container__j3JGa"};